import { EnvironmentFeatureFlagStateDto } from '@flagsync/skyline';
import { Row } from '@tanstack/react-table';
import * as React from 'react';
import { HTMLAttributes } from 'react';

import { useTargetedVariants } from '@/pages/authenticated/dashboard/flags/components/flag-table/cells/hooks/use-targeted-variants';
import { VariantName } from '@/components/variant-value';
import { cn } from '@/lib/utils';

export const CurrentlyServingCell = ({
  row,
  className,
}: {
  row: Row<EnvironmentFeatureFlagStateDto>;
} & HTMLAttributes<HTMLDivElement>) => {
  const variants = useTargetedVariants(row.original);

  const variantValues = variants.map((v, i) => {
    const index = row.original.featureFlag.variants.findIndex(
      (variant) => variant.variantId === v?.variantId,
    );
    return (
      <div key={v?.variantId} className="truncate">
        <VariantName variant={v} index={index !== -1 ? index : i} />
      </div>
    );
  });

  return (
    <div className={cn('flex flex-col space-y-2')}>
      <div
        className={cn('flex space-x-2 items-start', {
          'items-start': variantValues.length > 1,
          'items-center': variantValues.length === 1,
        })}
      >
        <div
          className={cn(
            'flex flex-col space-y-2 font-semibold max-w-[120px] md:max-w-fit',
            className,
          )}
        >
          {variantValues}
        </div>
      </div>
    </div>
  );
};

export const CurrentlyServingCellBase = ({
  flag,
  className,
}: {
  flag: EnvironmentFeatureFlagStateDto;
} & HTMLAttributes<HTMLDivElement>) => {
  const variants = useTargetedVariants(flag);

  const variantValues = variants.map((v, i) => {
    const index = flag.featureFlag.variants.findIndex(
      (variant) => variant.variantId === v?.variantId,
    );
    return (
      <div key={v?.variantId} className="truncate">
        <VariantName variant={v} index={index !== -1 ? index : i} />
      </div>
    );
  });

  return (
    <div className={cn('flex flex-col space-y-2')}>
      <div
        className={cn('flex space-x-2 items-start', {
          'items-start': variantValues.length > 1,
          'items-center': variantValues.length === 1,
        })}
      >
        <div
          className={cn(
            'flex flex-col space-y-2 font-semibold max-w-[120px] md:max-w-fit',
            className,
          )}
        >
          {variantValues}
        </div>
      </div>
    </div>
  );
};

export const CurrentlyServingMobileCell = ({
  flagState,
  className,
}: {
  flagState: EnvironmentFeatureFlagStateDto;
} & HTMLAttributes<HTMLDivElement>) => {
  const variants = useTargetedVariants(flagState);

  const variantValues = variants.map((v, i) => {
    const index = flagState.featureFlag.variants.findIndex(
      (variant) => variant.variantId === v?.variantId,
    );
    return (
      <div key={v?.variantId} className="truncate">
        <VariantName variant={v} index={index !== -1 ? index : i} />
      </div>
    );
  });

  return (
    <div className={cn('flex flex-col space-y-2')}>
      <div
        className={cn('flex space-x-2 items-start', {
          'items-start': variantValues.length > 1,
          'items-center': variantValues.length === 1,
        })}
      >
        <div
          className={cn(
            'flex flex-col space-y-1 font-semibold max-w-[120px] md:max-w-fit',
            className,
          )}
        >
          {variantValues}
        </div>
      </div>
    </div>
  );
};
